import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import Popup from "@my-dld/components/Popup/Popup";
import { IJOPDetailServiceEntry, IJOPRequestDetails, IRVSComplaint } from "./JOPRequests";
import { DetailsKV } from "../MyDLD/PropertyDetails";
import { LocaleUtil, StringUtil } from "@eres/core";
import TextAreaInputField from "@eres/forms-web/TextAreaInputField";
import { WebFormFieldProps } from "@eres/forms-web";
import StateHolder from "@eres/forms/StateHolder";
import { defaultErrorManager } from "@eres/forms/errormanager";
import { hideLoading, LoadableDataState, showErrorMessage, showLoading } from "@my-dld/utils/UIUtils";
import { ErrorContainer } from "@eres/forms";
import { checkNonEmpty } from "@my-dld/components/Form/FormField";
import Dropzone from "react-dropzone";
import DocumentInputField from "@my-dld/components/Form/DocumentInputField";
import { Docs } from "./JOPService";
import FormRow from "@eres/forms-web/FormRow";
import { OwnerCommitteeApi } from "../../ownercommitteeapi";
import { checkValidationErrorWithMessage } from "../../ownercommitteeapi/api";
import { OwnerCommitteeLookup, OwnerFeedbackRequest, ServiceRate } from "../../ownercommitteeapi/entities";
import { OwnerCommitteeLookupTransformer } from "../../ownercommitteeapi/utils";
import PickerInput from "@eres/forms-web/PickerInput";
import { IdExtractor } from "@my-dld/utils/LookupUtil";
import { Lookup } from "@eres/ejari-api/Entity";
import _ from "lodash";
import { DashboardSectionTitle } from "../MyDLD/Portfolio/Summary";
import { AttachmentInfo } from "@eres/ejari-api/Entity/tenant";
import { formatAppDate } from "@my-dld/utils/Utils";
import { Rating } from "react-simple-star-rating";
import { JOPApi } from "./Api";
import I8N from "@eres/core/dist/I8N";

interface Props {
	request: IJOPRequestDetails;
	details: IJOPDetailServiceEntry;
	transaction?: IRVSComplaint;
	onDismiss: () => void;
	onShowSuccess?: ( referenceNumber: string ) => void;
	submitOwnerFeedback?: boolean;
	title: string;
}

interface State extends LoadableDataState {
	lookups?: OwnerCommitteeLookup[];
	ownerFeedback?: string;
	attachments?: any;
	ownerStatus?: Lookup;
	serviceRate?: ServiceRate;
}

const MAX_SIZE = 2 * 1024 * 1000;
const MAX_PAGES = 10;

class JOPRequestDetailsPopup extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {
			loadState: "done",
			errorContainer: {}
		};
	}

	componentDidMount() {
		if ( this.props.submitOwnerFeedback && !this.state.lookups ) this.getLookups();
	}

	componentDidUpdate( prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any ) {
		if ( !_.isEqual( prevProps, this.props ) ) {
			this.setState( {
				errorContainer: {},
				ownerStatus: undefined,
				attachments: undefined,
				ownerFeedback: undefined,
			} );
			this.componentDidMount();
		}
	}

	handleRating = ( value: any ) => {
		this.setState( { serviceRate: value, errorContainer: { ...this.state.errorContainer, serviceRate: "" } } );
	};

	render() {
		const { details, request, submitOwnerFeedback, title, transaction } = this.props;
		console.log("DETAILS ___ ", details);
		const fieldProps: Partial<WebFormFieldProps<any, any>> = {
			holder: StateHolder.buildStateHolder( this ),
			errorManager: defaultErrorManager,
		};
		const errorContainer = this.state.errorContainer;
		const docs: AttachmentInfo[] = details.documents.map( d => {
			const url = d.url.split( "/" );
			return {
				DocumentID: d.id,
				DocumentURL: d.url,
				DocumentUrl: d.url,
				FileName: url?.[ url.length - 1 ],
			} as AttachmentInfo;
		} );
		return <Popup
			id={ "JOPDetailServiceEntry" }
			modalSubContainer={ "modal-dialog modal-dialog-centered modal-lg" }
			modalMainContainer={ "modal fade" }
			clickOutsideToDismiss={ false }
			showCloseButton={ true }
			closeClass={ "close modal-close-svg-icon" }
			closeSpanClass={ "close-svg-icon" }
			modalBodyContainer={ "modal-body" }
			showIcon={ false }
			title={ title }
			footer={ <>
				{ details.canSubmitOwnerFeedback && submitOwnerFeedback ? <button
					type="button" className="btn btn_style1 btn_1"
					data-uw-styling-context="true" onClick={ this.onSubmitFeedback }>{ Strings.submit }</button> : null }
				<button
					type="button" className="btn btn_style1 btn-grey"
					data-uw-styling-context="true" data-bs-dismiss="modal">{ Strings.close }</button>
			</> }
			onDismiss={ this.dismissModel }>
            <div className="flex-grid-half">
				<div className={ "flex-grid mb-2" }>
					<DetailsKV label={ Strings.request_number } value={ request.referenceNumber }/>
					<DetailsKV label={ Strings.category } value={ LocaleUtil.getLocalValue( details.category ) }/>
					{ details.subCategory && !StringUtil.isEmptyStringOrNull( details.subCategory.nameEn ) ?
						<DetailsKV label={ Strings.sub_category } value={ LocaleUtil.getLocalValue( details.subCategory ) }/> : null }

                    { transaction?.transactionNumber &&  <DetailsKV label={ Strings.rvs_number } value={ transaction?.transactionNumber }/> }
                    { !StringUtil.isEmptyStringOrNull( transaction?.transactionDate ) ?
                        <DetailsKV label={Strings.transaction_date} value={formatAppDate(transaction?.transactionDate?.asDate())} /> : null}
                    { transaction?.transactionStatus &&  <DetailsKV label={ Strings.rvs_status } value={ I8N.isRTL() ? transaction?.transactionStatus.arabicName : transaction?.transactionStatus.englishName}/> }
                    { !StringUtil.isEmptyStringOrNull( details.meetingDate ) ?
                        <DetailsKV label={Strings.owner_committee_meeting_date} value={formatAppDate(details.meetingDate?.asDate())} /> : null}
                </div>
                <div className={"flex-full flex-grid"}>
                     <DetailsKV label={Strings.description} value={details.description} />
					{ !StringUtil.isEmptyStringOrNull( details.companyFeedback ) ?
						<DetailsKV label={ Strings.company_feedback } value={ details.companyFeedback }/> : null }
					{ !StringUtil.isEmptyStringOrNull( details.ownerFeedback ) ?
						<DetailsKV label={ Strings.requester_feedback } value={ details.ownerFeedback }/> : null }
					{ transaction?.transactionRemarks &&  <DetailsKV label={ Strings.transaction_remarks } value={ transaction?.transactionRemarks }/> }
					{ transaction?.closeReasonName &&  <DetailsKV label={ Strings.close_reason } value={ I8N.isRTL() ? transaction?.closeReasonName.arabicName : transaction?.closeReasonName.englishName}/> }
                </div>
            </div>
				{ !submitOwnerFeedback && details.documents && details.documents.length > 0 ?
					<>
						<div className={ "row" }>
							<DashboardSectionTitle title={ Strings.documents }/>
						</div>
						<Docs documents={ docs }/>
					</> : null }
				{ details.canSubmitOwnerFeedback && submitOwnerFeedback ? <>
					<FormRow { ...fieldProps }>
						<PickerInput
                            items={this.state.lookups}
                            containerClassName="col-md-6"
							id={ "ownerStatus" }
							toIdentifier={ IdExtractor }
							label={ Strings.status_from_requester }
							required={ true }
                            isLoading={this.state.lookups == null} />
                        <div className="col-md-6">
                            <label className="d-flex mb-3"><span>{Strings.rating}</span></label>
						<Rating onClick={ this.handleRating } titleSeparator={ Strings.out_of }/>
						{ errorContainer.serviceRate != null ?
                                <div className={"invalid-feedback invalid-feedback-x"}>{errorContainer.serviceRate}</div> : null}
                            </div>
					</FormRow>
					<TextAreaInputField
                        {...fieldProps}
                        containerClassName="mt-3 mb-3"
						required={ true }
						id={ "ownerFeedback" }
						label={ Strings.comments }/>
					<FormRow { ...fieldProps }>
						<div className={ "row" }>
							<DashboardSectionTitle title={ Strings.documents }/>
						</div>
						<div key={ "doc_info" } className="col-12 form-group">
							<Dropzone
								multiple={ true }
								maxSize={ MAX_SIZE }
								onDropRejected={ this.onDropRejected }
								onDrop={ ( files: File[] ) => {
									this.onDrop( files );
								} }
								accept={ [ "image/png", "image/jpeg", "application/pdf" ] }>
								{ ( { getRootProps, getInputProps } ) => (
									<DocumentInputField
										{ ...getRootProps() }
										required={ false }
										dropZoneInputProps={ getInputProps() }
										label={ Strings.attached_documents }
										// isDocsAdded={ isDocsAdded }
										error={ errorContainer.attachments }
										// disabled={ ( docLookup.Docs && docLookup.Docs.length === maxPages ) }
									/>
								) }
							</Dropzone>
							<span>
		                        <small>{ Strings.tabu_upload_documents_note }</small><br/>
		                        <small>{ Strings.max_num_files + " : " + MAX_PAGES }</small>
		                    </span>
							<Docs onDelete={ this.onDelete } documents={ this.state.attachments }/>
						</div>
					</FormRow>
				</> : null }
		</Popup>;
	}

	getLookups = () => {
		JOPApi.getJOPServiceTaskStatus()
		.then( r => {
			if ( r && r.validationErrorsList && r.validationErrorsList.length > 0 ) {
				this.setState( {
					errorContainer: {
						...this.state.errorContainer,
						ownerStatus: OwnerCommitteeApi.getValidationError( r.validationErrorsList )
					}
				} );
			} else if ( r.response && r.response.items && r.response.items.length > 0 ) {
				this.setState( { lookups: r.response.items.map( OwnerCommitteeLookupTransformer ) } );
			}
		} )
		.catch( () => {
		} );
	};

	private dismissModel = () => {
		if ( this.props.onDismiss ) {
			this.props.onDismiss();
		}
		this.setState( { errorContainer: {} } );
	};

	validateForm = () => {
		const state = this.state;
		let isValid = true;
		let errorViews: ErrorContainer = {};
		isValid = checkNonEmpty( state, "ownerFeedback", errorViews ) && isValid;
		isValid = checkNonEmpty( state, "ownerStatus", errorViews ) && isValid;
		if ( state.serviceRate == null ) {
			isValid = false;
			errorViews.serviceRate = Strings.required;
		} else {
			delete errorViews.serviceRate;
		}
		this.setState( { errorContainer: errorViews } );
		return isValid;
	};

	onSubmitFeedback = () => {
		if ( this.validateForm() ) {
			this.dismissModel();
			showLoading();
			this.uploadDocuments()
			.then( docs => {
				const request: OwnerFeedbackRequest = {
					id: this.props.details.id,
					ownerFeedback: this.state.ownerFeedback!,
					documents: docs?.map( doc => ( { id: doc.documentId } ) ),
					ownerStatusId: this.state.ownerStatus?.Id!,
					serviceRate: this.state.serviceRate!,
				};
				JOPApi.submitOwnerFeedback( request.id, request )
				.then( r => {
					if ( r && r.validationErrorsList && r.validationErrorsList.length > 0 ) {
						showErrorMessage( OwnerCommitteeApi.getValidationError( r.validationErrorsList ) );
					} else if ( r && r.response && r.response.referenceNumber != null ) {
						this.props.onShowSuccess?.( r.response.referenceNumber );
					}
					hideLoading();
				} )
				.catch( e => {
					hideLoading();
					showErrorMessage( e );
				} );
			} )
			.catch( e => {
				hideLoading();
				showErrorMessage( e );
			} );
		}
	};

	onDropRejected = () => {
		this.setState( { errorContainer: { ...this.state.errorContainer, attachments: Strings.tabu_file_exceed_size } } );
	};

	private onDrop = ( files: File[] ) => {
		const docs = this.state.attachments;
		if ( MAX_PAGES > 1 ) {
			if ( docs && docs.length > 1 ) {
				let maxAllowed = ( MAX_PAGES - docs.length );
				if ( files.length > maxAllowed ) files = files.splice( 0, maxAllowed );
			} else if ( files.length > MAX_PAGES ) {
				files = files.splice( 0, MAX_PAGES );
			}
		}
		files.filter( x => x.type.startsWith( "image/" ) || x.type.startsWith( "application/pdf" ) )
		.forEach( file => this.addFile( file ) );
	};

	private addFile( file: File ) {
		const reader = new FileReader();
		reader.onload = () => {
			let d = this.state.attachments ? [ ...this.state.attachments ] : [];
			const binaryStr = reader.result;
			if ( d == null ) d = [];
			const newDoc = {
				Type: file.type,
				LocalData: binaryStr as string,
				FileName: file.name,
				localFile: file,
			};
			if ( MAX_PAGES > 1 ) {
				d.push( newDoc );
			} else {
				d = [ newDoc ];
			}
			let error = this.state.errorContainer;
			delete error.attachments;
			this.setState( {
				attachments: d,
				errorContainer: error,
			} );
		};
		reader.readAsDataURL( file );
	}

	onDelete = ( index: number ) => {
		const { attachments } = this.state;

		const d = attachments?.filter( ( _: any, i: number ) => i !== index );
		this.setState( {
			attachments: d,
		} );
	};

	uploadDocuments = () => {
		let uploadTasks: Promise<any>[] = [];
		const docs = this.state.attachments;
		docs?.map( ( doc: any ) => {
			if ( doc.documentId == null ) {
				uploadTasks.push( JOPApi.uploadJOPDocument( doc.localFile ).then( ( response ) => {
					return checkValidationErrorWithMessage( response );
				} ).then( response => {
					if ( response.responseCode === "Success" && response.response ) {
						doc.documentId = response.response.id;
						return Promise.resolve( doc );
					}
					return Promise.resolve( doc );
				} ).catch( reason => {
					return Promise.reject( reason.toString() );
				} ) );
			} else {
				uploadTasks.push( Promise.resolve( doc ) );
			}
		} );

		return Promise.all( uploadTasks );
	};
}

export default JOPRequestDetailsPopup;
